import {UI} from "stem-core/ui/UIBase";
import {Card} from "../../ui/Card.jsx";
import {CardItems} from "../../ui/CardItems.jsx";
import {Money} from "../../../../stem-core/localization/Money.js";
import type {AdminUser} from "../../../../client/state/AdminUserStore.js";


interface UserPreferencesOptions {
    user?: AdminUser;
}

export class UserPreferences extends UI.Element<UserPreferencesOptions> {
    render() {
        const {user} = this.options;
        const preferences = user.getPreferences();
        const currency = preferences.getDefaultCurrency();

        return (
            <Card title="Preferences">
                <CardItems
                    items={[
                        ["Auto pay enabled", preferences.autoPayEnabled ? "true" : "false"],
                        ["Article price limit", Money.format(preferences.articlePriceLimit, currency)],
                        ["Auto top up enabled", preferences.autoTopUpEnabled ? "true" : "false"],
                        ["Auto top up amount", Money.format(preferences.autoTopUpAmount, currency)],
                        ["Auto top up threshold", Money.format(preferences.autoTopUpThreshold, currency)],
                        ["Max wallet balance", Money.format(preferences.maxWalletBalance, currency)],
                        ["Top up daily limit", Money.format(preferences.topUpDailyLimit, currency)],
                        ["Top up monthly limit", Money.format(preferences.topUpMonthlyLimit, currency)],
                    ]}
                />
            </Card>
        );
    }
}


